import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { FormattedMessageWrappedInSpan } from '../../misc';

const InsufficientResultsInformation = props => {
  const {
    count,
    raceResultsUrl,
    tagWithStartNumber,
    showGpsSearchLink,
    showSmartSearchLink,
    intl,
    onDeepSearchClick,
    onCategorySearchClick,
    onGpsSearchClick,
  } = props;

  const link = (
    <a target="_blank" href={raceResultsUrl}>
      <FormattedMessageWrappedInSpan
        id="insufficientResultsView.checkStartnumber.link"
        defaultMessage="race-results"
      />
    </a>
  );

  return (
    <div className="insufficient-results-view-container">
      <div className="row">
        <div className="col-xs-16 col-sm-12 col-sm-offset-2">
          <h2 className="center-xs middle-xs">
            {count === 0 && (
              <FormattedMessageWrappedInSpan
                id="insufficientResultsView.title.noPhotos"
                defaultMessage="No photos found?"
              />
            )}
            {count !== 0 && (
              <FormattedMessageWrappedInSpan
                id="insufficientResultsView.title.notEnoughPhotos"
                defaultMessage="Not enough photos?"
              />
            )}
          </h2>
        </div>
      </div>
      <div className="row">
        {tagWithStartNumber && (
          <div className="insufficient-results-view-body col-xs-16 col-sm-12 col-sm-offset-2">
            <div className="insufficient-results-view-item">
              <h3>
                <FormattedMessageWrappedInSpan
                  id="insufficientResultsView.checkStartnumber.title"
                  defaultMessage="Check your start number"
                />
              </h3>
              <p>
                <FormattedMessageWrappedInSpan
                  id="insufficientResultsView.checkStartnumber.description"
                  defaultMessage="Did you use the correct start number? Please check your start number again!"
                />
                {raceResultsUrl && (
                  <FormattedMessageWrappedInSpan
                    id="insufficientResultsView.checkStartnumber.raceResults"
                    defaultMessage="You can double-check it in the {raceResults}"
                    values={{ raceResults: link }}
                  />
                )}
              </p>
            </div>
            <div className="insufficient-results-view-item">
                <h3>
                  <FormattedMessageWrappedInSpan
                    id="insufficientResultsView.addPhotos.title"
                    defaultMessage="Find & mark your photos"
                  />
                </h3>
                <p>
                  <FormattedMessageWrappedInSpan
                    id="insufficientResultsView.addPhotos.description"
                    defaultMessage="If no pictures are shown to you, we could not assign any of the pictures to your start number. This can happen if we could not read the start number. Maybe it was hidden, or just hard to read. But don't worry, there will still be pictures of you! We need your help to find them. Please use one of the options below to find pictures of you. You can simply mark the pictures with your start number."
                  />
                </p>
              </div>
            <div className="insufficient-results-view-item">
              <h3>
                <FormattedMessageWrappedInSpan
                  id="insufficientResultsView.options.title"
                  defaultMessage="Try our search system"
                />
              </h3>
              {showSmartSearchLink && count > 0 && (
                <div>
                  <div className="extended-search-title">
                    <a onClick={onDeepSearchClick}>
                      {intl.formatMessage(translations.smartSearchLink)}
                    </a>
                  </div>
                  <p>
                    <FormattedMessageWrappedInSpan
                      id="insufficientResultsView.options.smartSearch.description"
                      defaultMessage="Maybe you did the race together with a friend? Enter her/his start number and find photos around hers/his which may show you."
                    />
                  </p>
                </div>
              )}
              <div className="extended-search-title">
                <a onClick={onCategorySearchClick}>
                  {intl.formatMessage(translations.categorySearchLink)}
                </a>
              </div>
              <p>
                <FormattedMessageWrappedInSpan
                  id="insufficientResultsView.options.categories.description"
                  defaultMessage="All photos spots are listed in categories. Please choose a category and a time range of your expected passing time."
                />
              </p>
              {showGpsSearchLink && (
                <div>
                  <div className="extended-search-title">
                    <a onClick={onGpsSearchClick}>
                      {intl.formatMessage(translations.gpsSearchLink)}
                    </a>
                  </div>
                  <p>
                    <FormattedMessageWrappedInSpan
                      id="insufficientResultsView.options.gpsSearch.description"
                      defaultMessage="Did you use a GPS tracker? Download the GPS data from your tracker as a GPX file and upload it on our website. It will show you photos that match the recorded location and time."
                    />
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
        {!tagWithStartNumber && (
          <div className="insufficient-results-view-body col-xs-16 col-sm-12 col-sm-offset-2">
            <div className="no-face-match-results-view-item">
              <h3>
                <FormattedMessageWrappedInSpan
                  id="noFaceMatchResultsView.tryAnotherPhoto.title"
                  defaultMessage="Try with another photo"
                />
              </h3>
              <p>
                <FormattedMessageWrappedInSpan
                  id="noFaceMatchResultsView.tryAnotherPhoto.description"
                  defaultMessage="Please check that your face is not blurry and the only one on the photo!"
                />
              </p>
            </div>
            <div className="no-face-match-results-view-item">
              <h3>
                <FormattedMessageWrappedInSpan
                  id="insufficientResultsView.options.title"
                  defaultMessage="Try our search system"
                />
              </h3>
              {showSmartSearchLink && count > 0 && (
                <div>
                  <div className="extended-search-title">
                    <a onClick={onDeepSearchClick}>
                      {intl.formatMessage(translations.smartSearchLink)}
                    </a>
                  </div>
                  <p>
                    <FormattedMessageWrappedInSpan
                      id="noFaceMatchResultsView.options.smartSearch.description"
                      defaultMessage="You can use this feature to find your photos even if we couldn't mark them as yours."
                    />
                  </p>
                </div>
              )}
              <div className="extended-search-title">
                <a onClick={onCategorySearchClick}>
                  {intl.formatMessage(translations.categorySearchLink)}
                </a>
              </div>
              <p>
                <FormattedMessageWrappedInSpan
                  id="insufficientResultsView.options.categories.description"
                  defaultMessage="All photos spots are listed in categories. Please choose a category and a time range of your expected passing time."
                />
              </p>
              {showGpsSearchLink && (
                <div>
                  <div className="extended-search-title">
                    <a onClick={onGpsSearchClick}>
                      {intl.formatMessage(translations.gpsSearchLink)}
                    </a>
                  </div>
                  <p>
                    <FormattedMessageWrappedInSpan
                      id="insufficientResultsView.options.gpsSearch.description"
                      defaultMessage="Did you use a GPS tracker? Download the GPS data from your tracker as a GPX file and upload it on our website. It will show you photos that match the recorded location and time."
                    />
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const translations = defineMessages({
  smartSearchLink: {
    id: 'insufficientResultsView.smartSearchLink',
    defaultMessage: 'Smart Search',
  },
  categorySearchLink: {
    id: 'insufficientResultsView.categorySearchLink',
    defaultMessage: 'Categories',
  },
  gpsSearchLink: {
    id: 'insufficientResultsView.gpsSearchLink',
    defaultMessage: 'GPS Search',
  },
});

InsufficientResultsInformation.propTypes = {
  count: PropTypes.number,
  raceResultsUrl: PropTypes.string,
  tagWithStartNumber: PropTypes.bool,
  showGpsSearchLink: PropTypes.bool,
  showSmartSearchLink: PropTypes.bool,
  intl: PropTypes.object,
  onDeepSearchClick: PropTypes.func,
  onCategorySearchClick: PropTypes.func,
  onGpsSearchClick: PropTypes.func,
};

export default injectIntl(InsufficientResultsInformation);
